import React from "react";
import { Form, Select } from "antd";
const { Option } = Select;

const Estabelecimento = ({ estabelecimentoSelecinado, handleChangeSelectEstabelecimento, estabelecimentos, getFieldDecorator }) => (
    <Form.Item label="Estabelecimento">
        {getFieldDecorator("estabelecimento", {
            rules: [{ required: true, message: "Campo obrigatório" }],
            initialValue: estabelecimentoSelecinado
        })(
            <Select placeholder="Selecionar" allowClear={true} onChange={handleChangeSelectEstabelecimento}>
                {estabelecimentos.map(estabelecimento => (
                    <Option key={estabelecimento.id} value={estabelecimento.id}>
                        {estabelecimento.nome}
                    </Option>
                ))}
            </Select>
        )}
    </Form.Item>
);

export default Estabelecimento;
